import { useQuery } from "@tanstack/react-query";
import { fetchStores, type StoresFilter, type StoresResponse } from "../lib/api";

export type { StoresFilter } from "../lib/api";

export function useStores(filter: StoresFilter) {
  return useQuery<StoresResponse>({
    queryKey: ["stores", filter],
    queryFn: () => fetchStores(filter),
    // フィルタ切替時に前の結果を保持し、シートが一瞬空白になるのを防ぐ。
    placeholderData: (prev) => prev,
  });
}
